export class BankEntriesTransformer {
  constructor({ rows, country, selectedOption }) {
    if (rows.length === 0) {
      throw new Error('No rows on creating a transformer');
    }
    this.rows = rows;
    this.bankEntriesDictionary = {
      br: {
        BANK_STATEMENT_BR_ITAU_XLSX: {
          originName: 'Pagador',
          dueDate: 'Vencimento',
          date: 'Data de pagamento',
          amount: 'Valor(R$)',
          portfolio: 'Carteira',
          bankTransactionIdentificator: 'Nosso Número',
          bankTransactionNumber: 'Seu Número',
          defaultingStatus: 'Situação da cobrança',
          defaultingMethod: 'Tipo de cobrança'

        },
        BANK_STATEMENT_BR_ITAU_TXT: {
          originName: 'Pagador',
          dueDate: 'Vencimento',
          date: 'Data de pagamento',
          amount: 'Valor(R$)',
          portfolio: 'Carteira',
          bankTransactionIdentificator: 'Nosso Número',
          bankTransactionNumber: 'Seu Número',
          defaultingStatus: 'Situação da cobrança',
          defaultingMethod: 'Tipo de cobrança'
        },
        BANK_STATEMENT_BR_SANTANDER: {
          bankTransactionNumber: 'Seu Número',
          bankTransactionIdentificator: 'Nosso Número',
          dueDate: 'Vencimento',
          date: 'Data da Liquidação',
          principal: 'Valor do Título (R$)',
          amount: 'Valor Cobrado (R$)',
          lates: 'Oscilação (R$)',
          originName: 'Pagador',
          defaultingMethod: 'Conta Cobrança'
        }
      }[selectedOption],
      cl: {
        BANK_TRANSFERS_REPORT_CL_BCI: {
          bankTransactionNumber: 'Nº transacción',
          transferDate: 'Fecha recepción',
          addresseeIdNumber: 'Rut Empresa beneficiario',
          addresseeName: 'Nombre Empresa beneficiario',
          addresseeAccountNumber: 'Cuenta Beneficiario / Vale Vista',
          paymentType: 'Producto',
          originIdNumber: 'Rut Ordenante',
          originName: 'Nombre Ordenante',
          originBank: 'Banco Ordenante',
          originAccountNumber: 'Cuenta Ordenante',
          amount: 'Monto',
          paymentMethod: 'Forma de pago',
          documentNumber: 'Numero de documento ',
          bankOffice: 'Oficina de retiro'
        },
        BANK_STATEMENT_CL_BCI: {
          transferDate: 'Fecha transacción',
          accountingDate: 'Fecha contable (*)',
          bankOffice: 'Oficina',
          movement: 'Movimiento',
          documentNumber: 'N° documento',
          outcome: 'Cargo (-)',
          income: 'Abono (+)',
          detailedGloss: 'Glosa detalle',
          purchaseType: 'Tipo de compra',
          businessName: 'Nombre del comercio',
          businessCategory: 'Rubro',
          businessIdNumber: 'RUT del comercio',
          transactionCode: 'Código de transacción',
          service: 'Servicio',
          clientIdNumber: 'N° Cliente',
          enterprise: 'Empresa',
          enterpriseIdNumber: 'RUT de la empresa',
          originIdNumber: 'RUT de origen',
          originName: 'Nombre de origen',
          originAccountType: 'Tipo Cuenta de origen',
          originAccountNumber: 'N° de Cuenta de origen',
          originBank: 'Banco de origen',
          paymentType: 'Descripción tipo de pago',
          email: 'Correo electrónico',
          internalGLoss: 'Glosa interna',
          transferCode: 'Código transferencia',
          addresseIdNumber: 'RUT destinatario',
          addresseName: 'Nombre destinatario',
          addresseAccountType: 'Tipo Cuenta destinatario',
          addresseAccountNumber: 'Cuenta destinatario',
          addresseBank: 'Banco destinatario',
          addresseEmail: 'Mail destinatario',
          transferComment: 'Comentario transferencia',
          secondTransferCode: 'Código transferencia',
          city: 'Ciudad',
          county: 'Comuna',
          movementType: 'Tipo de movimiento',
          creditCardsLastDigits: 'Ultimos 4 digitos de tarjeta',
          operationNumber: 'N° Operación',
          folio: 'Folio',
          fileName: 'Nombre archivo',
          payrollName: 'Nombre nomina',
          paymentDate: 'Fecha de pago',
          uploadDate: 'Fecha de carga',
          rejectionReason: 'Motivo rechazo',
          billingCompanyIdNumber: 'RUT empresa facturadora',
          billingCompanyName: 'Razón social empresa facturadora',
          identificationNumber: 'N° de id',
          address: 'Dirección',
          currency: 'Moneda',
          operationAmount: 'Monto Operación'
        },
        BANK_DEPOSITS_CL_BCI: {
          transferDate: 'Fecha [YYYY-MM-DD]',
          serialNumber: 'Serial',
          amount: 'Monto [123456]',
          name: 'Nombre',
          idNumber: 'RUT'
        }
      }[selectedOption]
    }[country];
    if (!this.bankEntriesDictionary) {
      throw new Error('Bad params on creating a transformer');
    }
  }

  translateJsonToBankEntriesInput() {
    // recorre cada linea del archivo
    return this.rows.map(row => {
      // para cada línea recorre el diccionario completo traduciendo sus valores
      const entry = Object.entries(this.bankEntriesDictionary)
        .reduce((entryToUpdate, [dictionaryKey, dictionaryValue]) => {
          const entryIn = entryToUpdate;
          const rowValue = row[dictionaryValue];
          if (rowValue !== undefined) {
            const isDate = dictionaryKey.includes('date') || dictionaryKey.includes('Date');
            entryIn[dictionaryKey] = isDate && rowValue ? rowValue.replace('x', '') : rowValue;
          }
          return entryIn;
        }, {});
      return entry;
    });
  }
}
